import React, { useState } from "react";
import { ArrowLeft, ArrowRight, Search, } from "lucide-react";
import { toast } from "sonner";
import { inventory } from "../../data/quoteData";
import Summary from "../components/Summary";
export default function Step2({ data, setData, next, back, }) {
  const [category, setCategory] = useState("Living Room");
  const [search, setSearch] = useState("");
  const items = (inventory[category] || []).filter(([name]) =>
    name.toLowerCase().includes(search.toLowerCase())
  );
  const update = (name, delta) => {
    setData((prev) => {
      const nextItems = { ...(prev.items || {}), };
      const currentQty = Number(nextItems[name]) || 0;
      const newQty = Math.max(0, currentQty + delta);
      if (newQty === 0) {
        delete nextItems[name];
      } else {
        nextItems[name] = newQty;
      }
      return { ...prev, items: nextItems, };
    });
  };
  const total = Object.values(data.items || {}).reduce((sum, qty) => sum + (Number(qty) || 0), 0);
  const selectedItemTypes = Object.keys(data.items || {}).length;
  const handleNext = () => {
    if (total === 0) {
      toast.error("Inventory selection required",
        {
          description: "Please select at least one item to continue.",
        });
      return;
    }
    toast.success("Inventory completed",
      {
        description: `${total} item${total > 1 ? "s" : ""} selected. Let's continue.`,
      });
    next();
  };
  return (
    <div className="page-grid with-summary">
      <main className="form-card">
        <div className="card-title-row">
          <div>
            <h2>2. Items & Inventory</h2>
            <p className="section-subtitle">Select the items you want to move from the categories below.</p>
          </div>
          <div className="search-box">
            <Search size={18} />
            <input type="text" placeholder="Search items..." value={search} onChange={(e) => setSearch(e.target.value)} />
          </div>
        </div>
        {total > 0 && (
          <div className="inventory-selected-bar">
            <div>
              <strong>{total} items selected</strong>
              <span>{selectedItemTypes} item types</span>
            </div>
            <button type="button" onClick={() => { setData((prev) => ({ ...prev, items: {}, })); }}>Clear All</button>
          </div>
        )}
        <div className="inventory-category-wrapper">
          <div className="inventory-category-list">
            {Object.keys(inventory).map((c) => (
              <button type="button" key={c} className={category === c ? "selected" : ""}
                onClick={() => { setCategory(c); setSearch(""); }}>{c}</button>
            ))}
          </div>
        </div>
        <div className="item-area">
          <div className="item-area-header">
            <div>
              <h3>{category}</h3>
              <span>
                {items.length} item
                {items.length !== 1 ? "s" : ""}</span>
            </div>
          </div>
          <div className="item-list">
            {items.length > 0 ? (
              items.map(([name]) => {
                const quantity = Number(data.items?.[name]) || 0;
                return (
                  <div className={"inventory-item " + (quantity > 0 ? "selected" : "")} key={name}>
                    <div className="inventory-item-info">
                      <strong>{name}</strong>
                      {quantity > 0 && (
                        <span>{quantity} selected</span>
                      )}
                    </div>
                    <div className="qty-control">
                      <button type="button" onClick={() => update(name, -1)}
                        disabled={quantity === 0}
                        aria-label={`Decrease ${name}`}>−</button>
                      <span>{quantity}</span>
                      <button type="button" onClick={() => update(name, 1)}
                        aria-label={`Increase ${name}`}>+</button>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="no-items">No items found.</div>
            )}
          </div>
        </div>
        {total === 0 && (
          <div className="required-message">Please select at least one item to continue.</div>
        )}
        <div className="actions">
          <button type="button" className="back ghost" onClick={back}><ArrowLeft size={17} />Back</button>
          <button type="button" className="primary" onClick={handleNext}>Next: Pickup & Delivery<ArrowRight size={18} /></button>
        </div>
      </main>
      <Summary data={data} total={total} />
    </div>
  );
}